import request, { bdService, noTokenService } from '@/utils/request'

// 登录
export function oauthToken(data: any) {
  // return request({
  //   url: 'api/uaa/oauth/token',
  //   method: 'post',
  //   data,
  //   // headers: { 'content-type': 'application/x-www-form-urlencoded' },
  // })
  return noTokenService({
    url: 'api/uaa/oauth/token',
    method: 'post',
    data,
  })
}

// 查询所有值集编码
export function dictionaryAll(data: any) {
  return request({
    url: 'api/pps/dictionary/_all',
    method: 'get',
  })
}

// 根据值集编码查询字典
export function dictionaryID(data: any) {
  return request({
    url: `api/pps/dictionary/${data.id}/items`,
    method: 'get',
  })
}
